import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { InterventionsService } from '../../services/interventions.service'
import { InterventionRescheduleService } from '../../services/intervention-reschedule.service'
import { ToastService } from '../../../../shared/services/toast.service'
import { CommonModule } from '@angular/common'
import { ButtonModule } from 'primeng/button'
import { CardModule } from 'primeng/card'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { InterventionRescheduleStepsComponent } from '../intervention-reschedule-steps/intervention-reschedule-steps.component'

@Component({
  selector: 'app-intervention-reschedule',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    CardModule,
    ProgressSpinnerModule,
    InterventionRescheduleStepsComponent,
  ],
  templateUrl: './intervention-reschedule.component.html',
  styleUrls: ['./intervention-reschedule.component.scss'],
})
export class InterventionRescheduleComponent implements OnInit {
  interventionId: number | null = null
  erpSource: string | null = null
  loading = true
  error: string | null = null

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private interventionsService: InterventionsService,
    private rescheduleService: InterventionRescheduleService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.interventionId = Number(params.get('id'))
      this.erpSource = params.get('erpSource')

      if (!this.interventionId || !this.erpSource) {
        this.error = "Paramètres d'URL invalides"
        this.loading = false
        return
      }

      // Vérifier que l'intervention existe
      this.interventionsService
        .show(this.interventionId, this.erpSource)
        .subscribe({
          next: (intervention) => {
            this.loading = false
          },
          error: (err) => {
            this.loading = false
            this.error = "Impossible de charger l'intervention"
            console.error(err)
          },
        })
    })
  }

  goBack(): void {
    const url = this.router.url
    const baseUrl = url.substring(0, url.indexOf('/reschedule'))
    this.router.navigateByUrl(baseUrl)
  }
}
